import type { common as EN } from '../en/common';

/** German for `common.*`. Typed against the English source, so a missing key fails the build. */
export const common: Record<keyof typeof EN, string> = {
  'common.cancel': 'Abbrechen',
  'common.save': 'Speichern',
  'common.delete': 'Löschen',
  'common.close': 'Schließen',
  'common.create': 'Erstellen',
  'common.confirm': 'Bestätigen',
  'common.remove': 'Entfernen',
  'common.edit': 'Bearbeiten',
  'common.rename': 'Umbenennen',
  'common.retry': 'Erneut versuchen',
  'common.loading': 'Wird geladen…',
  'common.search': 'Suchen…',
};
